function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { createPrivateAppsPricingDataReceivedAction, createSetUserPrivateOffersLoadingAction, createUserPrivateOffersAction } from './actions';
import * as armRestClient from '@shared/services/http/armRestClient';
import { Constants } from '../utils/constants';
import { stringifyError } from '@shared/utils/errorUtils';
import { telemtry } from './thunkActions';
export function ensurePrivateOffer(id, billingRegion, getState) {
    return _async_to_generator(function*() {
        var _offer_pricingInformation;
        const { isMSAUser, privateOffers } = getState().users;
        if (isMSAUser) {
            return null;
        }
        const offer = privateOffers.dataList.find(({ entityId })=>entityId === id);
        telemtry(Constants.Telemetry.Action.GetPrivateOffer, 'checking for spesific private offer', {
            id
        });
        if ((offer === null || offer === void 0 ? void 0 : (_offer_pricingInformation = offer.pricingInformation) === null || _offer_pricingInformation === void 0 ? void 0 : _offer_pricingInformation.billingRegion) === billingRegion) {
            return offer;
        } else {
            return armRestClient.getUserPrivateApp(id, billingRegion);
        }
    })();
}
export function getUserPrivateOffers() {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { config: { isEmbedded, billingCountryCode: billingRegion }, users: { isMSAUser, signedIn, tid } } = getState();
            if (!signedIn || isEmbedded || isMSAUser) {
                dispatch(createSetUserPrivateOffersLoadingAction(false));
                return null;
            }
            const action = Constants.Telemetry.Action.GetPrivateOffers;
            const start = Date.now();
            telemtry(action, Constants.Telemetry.ActionModifier.Start, {
                tid,
                billingRegion
            });
            try {
                dispatch(createSetUserPrivateOffersLoadingAction(true));
                const privateOffersResponse = yield armRestClient.getUserPrivateApps(billingRegion);
                dispatch(createUserPrivateOffersAction({
                    apps: privateOffersResponse,
                    billingRegion
                }));
                dispatch(createSetUserPrivateOffersLoadingAction(false));
                const startingPrices = privateOffersResponse.reduce((startingPrices, app)=>{
                    startingPrices[app.entityId] = app.startingPrice;
                    return startingPrices;
                }, {});
                const pricingPayload = {
                    pricingData: startingPrices,
                    countryCode: billingRegion
                };
                dispatch(createPrivateAppsPricingDataReceivedAction(pricingPayload));
                telemtry(action, Constants.Telemetry.ActionModifier.End, {
                    tid,
                    duration: Date.now() - start
                });
                return null;
            } catch (error) {
                dispatch(createSetUserPrivateOffersLoadingAction(false));
                telemtry(action, Constants.Telemetry.ActionModifier.Error, {
                    tid,
                    duration: Date.now() - start,
                    error: stringifyError(error)
                });
                return null;
            }
        })();
    };
}
